// @flow
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { createNewConversation, updateElectronCaptionMode } from '../../../actions';
import { setCCMode, setShowBubbleAboveCCMode } from '../../../actions/cc-mode';
import { setRate, setRateConversationOpen, setRateHover } from '../../../actions/rate-conversation';
import { fetchAvaProfileMetrics } from '../../../actions/session';

import RatingView from './RatingView';

const mapStateToProps = ({
  rateConversation: { conversationStatus, isOpen, rate, rateHover },
  scribeSession: { captioner },
}) => ({
  conversationStatus,
  isRatingOpen: isOpen,
  rate,
  rateHover,
  user: captioner,
});

const mapDispatchToProps = {
  createNewConversation,
  fetchAvaProfileMetrics,
  setCCMode,
  setRate,
  setRateConversationOpen,
  setRateHover,
  setShowBubbleAboveCCMode,
  updateElectronCaptionMode,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RatingView));
